import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import { StaticImage } from 'gatsby-plugin-image';

import colors from '../../colors';
import Container from '../styled/Container';
import device from '../../device';
import fontSize from '../../fontSize';
import layoutSize from '../../layoutSize';
import SectionTitle from '../styled/SectionTitle';

const AboutSection = styled.section`
  width: 100%;
  padding: ${layoutSize[7]} ${layoutSize[2]} 20% ${layoutSize[2]};
  background-image: ${colors.gradient};
  clip-path: polygon(0 0, 100% 0, 100% 90%, 0 100%);
  @media ${device.laptop} {
    padding: ${layoutSize[7]} ${layoutSize[2]} 10% ${layoutSize[2]};
    clip-path: polygon(0 0, 100% 0, 100% 80%, 0 100%);
  }
`;

const AboutContainer = styled(Container)`
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const AboutSectionTitle = styled(SectionTitle)`
  color: white;
`;

const AboutWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media ${device.tablet} {
    flex-direction: row;
  }
`;

const ImageContainer = styled.div`
  margin-bottom: ${layoutSize[8]};
  padding: 0 ${layoutSize[4]};
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media ${device.tablet} {
    width: 50%;
  }
`;

const ImageWrapper = styled.div`
  border-radius: 2.5px;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  overflow: hidden;
`;

const AboutCopyContainer = styled.div`
  padding: 0 ${layoutSize[4]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  @media ${device.tablet} {
    width: 50%;
  }
  @media ${device.laptop} {
    text-align: left;
  }
`;

const AboutCopy = styled.p`
  margin-bottom: ${layoutSize[3]};
  color: white;
  font-size: ${fontSize[3]};
  line-height: ${fontSize[6]};
`;

const About = () => (
  <AboutSection id="about">
    <AboutContainer>
      <Fade delay={300} triggerOnce>
        <AboutSectionTitle>ABOUT ME</AboutSectionTitle>
      </Fade>
      <AboutWrapper>
        <ImageContainer>
          <Fade direction="bottom" triggerOnce duration={1000} delay={600}>
            <ImageWrapper>
              <StaticImage
                src="../../images/hs.png"
                alt="An image of the author smiling."
                placeholder="blurred"
                width={350}
                layout="constrained"
              />
            </ImageWrapper>
          </Fade>
        </ImageContainer>
        <AboutCopyContainer>
          <Fade direction="left" triggerOnce duration={1000} delay={1000}>
            <AboutCopy>
              I specialize in front-end and full-stack web development primarily using JavaScript,
              TypeScript, NodeJS, and React.
            </AboutCopy>
            <AboutCopy>
              My experience as a product manager and background in psychology allow me to deeply
              understand the software development process and build thoughtful user experiences.
            </AboutCopy>
            <AboutCopy>
              I find most things interesting and would love to hear what you&apos;re working on.
              Don&apos;t hesitate to reach out!
            </AboutCopy>
          </Fade>
        </AboutCopyContainer>
      </AboutWrapper>
    </AboutContainer>
  </AboutSection>
);

export default About;
